(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velisana-global-overrides"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var transparentProductImage =
      'https://cdn.shopify.com/s/files/1/0989/7269/6908/files/VELISANA-Silhouette-freigestellt.png?v=1785538383';

    function toArray(items) {
      return Array.prototype.slice.call(items || []);
    }

    function getButtonLabel() {
      var language = (document.documentElement.lang || 'de').toLowerCase().split('-')[0];
      var labels = {
        de: 'In den Warenkorb',
        en: 'Add to cart',
        fr: 'Ajouter au panier',
        it: 'Aggiungi al carrello',
        nl: 'In winkelwagen',
        tr: 'Sepete ekle',
        sv: 'Lägg i varukorgen'
      };

      return labels[language] || labels.de;
    }

    function findCartImages(scope) {
      var images = [];

      if (scope && scope.matches && scope.matches('.cart-items__media-image')) {
        images.push(scope);
      }

      if (scope && scope.querySelectorAll) {
        images = images.concat(toArray(scope.querySelectorAll('.cart-items__media-image')));
      }

      return images;
    }

    function fixCartImages(scope) {
      findCartImages(scope || document).forEach(function (image) {
        var row = image.closest('.cart-items__table-row');
        var titleElement = row ? row.querySelector('.cart-items__title') : null;
        var title = titleElement ? titleElement.textContent.trim() : '';
        var source = image.currentSrc || image.getAttribute('src') || '';
        var isVelisana = /velisana\s+silhouette/i.test(title) || /VELISANA-Silhouette-Kaps-Ds/i.test(source);

        if (!isVelisana || image.dataset.vsImageCorrected === 'true') return;

        image.dataset.vsImageCorrected = 'true';
        image.setAttribute('src', transparentProductImage + '&width=500');
        image.setAttribute(
          'srcset',
          transparentProductImage + '&width=250 250w, ' + transparentProductImage + '&width=500 500w'
        );
        image.setAttribute('alt', title || 'Velisana Silhouette');
      });
    }

    function getSelectedPlan(root) {
      return (
        root.querySelector('.vs-sales-plan.is-selected:not([disabled])') ||
        root.querySelector('[data-vs-variant]:not([disabled])')
      );
    }

    function initStickyPurchaseBar(root) {
      if (!root || root.dataset.vsStickyBarReady === 'true') return;

      root.dataset.vsStickyBarReady = 'true';

      var previousMobileBar = root.querySelector('[data-vs-mobile-bar]');

      if (previousMobileBar) previousMobileBar.classList.add('vs-mobile-bar-replaced');
      if (root.querySelector('[data-vs-global-mobile-bar]')) return;

      var topBuybox = root.querySelector('.vs-sales-buybox--hero');
      var topBuyButton = topBuybox ? topBuybox.querySelector('[data-vs-buy]') : null;
      var finalBuybox = root.querySelector('#vs-purchase-bottom');
      var planButtons = toArray(root.querySelectorAll('[data-vs-variant]'));

      if (!topBuybox || !topBuyButton || !planButtons.length) return;

      var bar = document.createElement('div');
      var copy = document.createElement('span');
      var planLabel = document.createElement('span');
      var price = document.createElement('strong');
      var button = document.createElement('a');

      bar.className = 'vs-sticky-purchase-bar';
      bar.setAttribute('data-vs-global-mobile-bar', '');
      bar.setAttribute('aria-hidden', 'true');

      copy.className = 'vs-sticky-purchase-bar__copy';
      copy.setAttribute('aria-live', 'polite');
      copy.appendChild(planLabel);
      copy.appendChild(price);

      button.className = 'vs-sticky-purchase-bar__button';
      button.textContent = root.dataset.mobileBuyLabel || getButtonLabel();

      bar.appendChild(copy);
      bar.appendChild(button);
      root.appendChild(bar);

      function syncBar() {
        var selected = getSelectedPlan(root);

        if (!selected) return;

        var variantId = selected.dataset.vsVariant || '';
        var selectedLabel =
          selected.dataset.vsPlanLabel ||
          (selected.querySelector('.vs-sales-plan-name') || {}).textContent ||
          '';
        var selectedPrice =
          selected.dataset.vsPrice ||
          (selected.querySelector('.vs-sales-plan-price') || {}).textContent ||
          '';
        var rootUrl = root.dataset.rootUrl || '/';

        if (rootUrl.charAt(rootUrl.length - 1) !== '/') rootUrl += '/';

        planLabel.textContent = selectedLabel.trim();
        price.textContent = selectedPrice.trim();
        button.href = variantId ? rootUrl + 'cart/' + variantId + ':1' : topBuyButton.href;
      }

      function updateVisibility() {
        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var menuIsOpen = Boolean(document.querySelector('.menu-drawer-container[open]'));
        var triggerBounds = topBuyButton.getBoundingClientRect();
        var finalBounds = finalBuybox ? finalBuybox.getBoundingClientRect() : null;
        var topButtonHasPassed = triggerBounds.bottom <= 0;
        var finalBuyboxIsVisible = finalBounds
          ? finalBounds.top < window.innerHeight && finalBounds.bottom > 0
          : false;
        var shouldShow = isMobile && topButtonHasPassed && !finalBuyboxIsVisible && !menuIsOpen;

        bar.classList.toggle('is-visible', shouldShow);
        bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }

      var framePending = false;

      function requestUpdate() {
        if (framePending) return;

        framePending = true;
        window.requestAnimationFrame(function () {
          framePending = false;
          syncBar();
          updateVisibility();
        });
      }

      root.addEventListener('click', function (event) {
        if (event.target.closest('[data-vs-variant]')) requestUpdate();
      });

      document.addEventListener('click', requestUpdate, true);
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);

      syncBar();
      updateVisibility();
    }

    function initAll(scope) {
      var context = scope || document;

      fixCartImages(context);

      if (context.matches && context.matches('[data-vs-sales]')) {
        initStickyPurchaseBar(context);
      }

      if (context.querySelectorAll) {
        toArray(context.querySelectorAll('[data-vs-sales]')).forEach(initStickyPurchaseBar);
      }
    }

    function start() {
      initAll(document);

      if (!document.body || typeof MutationObserver !== 'function') return;

      var observer = new MutationObserver(function (records) {
        records.forEach(function (record) {
          toArray(record.addedNodes).forEach(function (node) {
            if (node.nodeType === 1) initAll(node);
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
